export default "<div class=\"login\">\r\n    <div class=\"container iner-login px-3 py-5\">\r\n        <p>dashboard works!</p>\r\n    </div>\r\n</div>\r\n"